export function formatVerifyFailureMessage(status: number, detail: string): string {
  if (status === 401) {
    return "Sign-in verification failed. Your session may have expired - please try again.";
  }
  if (status === 502) {
    return "Cannot reach the identity provider. Please try again in a moment.";
  }
  if (status >= 500) {
    return "The server could not complete sign-in. Please try again or contact support.";
  }
  return detail.trim() || `Verification failed (HTTP ${status}).`;
}

export const NO_TOKEN_FOR_VERIFY =
  "No token was returned from the identity provider. Please try signing in again.";
